import { Reset, Theme } from "@bluframe/blublocks"
import styled from "styled-components"
import mediaQueries from "styles/mediaQueries"

export const Wrapper = styled.div`
  align-items: center;
  background: ${({ theme }: { theme: Theme }) =>
    theme.palette.primary.contrast};
  column-gap: 20px;
  display: grid;
  grid-template-columns: auto 1fr;
  justify-items: end;

  & p {
    margin-bottom: 0;
  }
`

export const ListAndAdd = styled.div`
  align-items: center;
  column-gap: 20px;
  display: grid;
  grid-template-columns: 1fr auto;
`

export const Ul = styled(Reset.Ul)`
  align-items: center;
  column-gap: 10px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  ${mediaQueries.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`

export const ModalWrapper = styled.div`
  display: grid;
  justify-items: center;
  row-gap: 30px;
`
